import { FC, useRef, useState } from "react";

import { AIAssessmentEvaluationDialog } from "./AIAssessmentEvaluationDialog";
import { HumanAssessedSubmission } from "./evaluation";

import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppSelector } from "store/index";
import {
  NestedPageOutcomeType,
  selectCurrentSectionTitle,
  selectCurrentUser,
} from "store/selectors";

type AIAssessmentEvaluationButtonProps = {
  hasOutcomeAssessments: boolean;
  humanAssessedSubmissions: HumanAssessedSubmission[];
  page: PageType;
  pageOutcomes: NestedPageOutcomeType[];
};

export const AIAssessmentEvaluationButton: FC<AIAssessmentEvaluationButtonProps> = ({
  hasOutcomeAssessments,
  humanAssessedSubmissions,
  page,
  pageOutcomes,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const currentUser = useAppSelector(selectCurrentUser);
  const sectionTitle = useAppSelector(selectCurrentSectionTitle) ?? "";

  const closeDialog = () => {
    setIsDialogOpen(false);
    window.requestAnimationFrame(() => triggerRef.current?.focus());
  };

  return (
    <>
      {/* Temporary MBACC AI-evaluation export; remove after the pilot unless retention is separately approved. */}
      <SquareButton
        className={hasOutcomeAssessments ? "mb-2 w-full" : "w-full"}
        kind="tertiary"
        ref={triggerRef}
        size="m"
        onClick={() => setIsDialogOpen(true)}
      >
        {t("assessment.ai_evaluation.open")}
      </SquareButton>

      {isDialogOpen && (
        <AIAssessmentEvaluationDialog
          feedbackStyleApplied={Boolean(currentUser?.assessment_ai_feedback_style?.trim())}
          humanAssessedSubmissions={humanAssessedSubmissions}
          page={page}
          pageOutcomes={pageOutcomes}
          sectionTitle={sectionTitle}
          onClose={closeDialog}
        />
      )}
    </>
  );
};
